import React from 'react';
import { CSSObject } from 'styled-components';
import { DividerWrapper } from './Divider.styles';

interface DividerProps {
  space?: number;
  styles?: CSSObject;
}

const Divider: React.FC<DividerProps> = ({ children, styles, space = 2 }) => {
  return (
    <DividerWrapper space={space} role="separator" style={styles}>
      <span />
      {children && <span className="text">{children}</span>}
      <span />
    </DividerWrapper>
  );
};

export default Divider;
